import React, { Fragment, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import moment from "moment";

const CallbackForm = () => {
    const {
        register,
        handleSubmit,
        setValue,
        trigger,
        watch,
        unregister,
        reset,
        formState: { errors, isValid },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            digitalPayment: "oneHourCall", // 👈 set the default selected radio
        },
    });

    // const digitalPayment = watch("digitalPayment");

    const [sheduleCall, setSheduleCall] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const maxAllowedDate = new Date().setDate(selectedDate.getDate() + 60);
    const [selectedTime, setSelectedTime] = useState("");
    const [sminTime, setsMinTime] = useState(new Date().setHours(9, 0, 0));
    const [smaxTime, setsMaxTime] = useState(new Date().setHours(17, 0, 0));

    const [show, setShow] = useState(false);
    const [otp, setOtp] = useState("");
    const [invalidOtpError, setInvalidOtpError] = useState("");
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [sendOtpData, setSendOTPData] = useState(null);
    const [showFormSubmit, setshowFormSubmit] = useState(null);
    const [errorFormSubmit, seterrorFormSubmit] = useState(null);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        console.log("this is digital payment", sheduleCall);
        if (sheduleCall) {
            register("time", {
                required: "Time is required",
            });
            register("date", {
                required: "Date is required",
            });
        } else {
            unregister("time");
            unregister("date");
            setValue("time", null);
            setValue("date", null);
        }
    }, [sheduleCall, register, unregister, setValue]);

    const handleRadioChange = (event) => {
        setSheduleCall(event.target.id === "sheduleCall");
    };

    const onReCAPTCHAChange = (token) => {
        setRecaptchaToken(token);
        console.log("reCAPTCHA token:", token);
    };

    const submitForm = (formData) => {
        console.log("Form Submitted:", formData);
        sendOTP(formData);
    };

    const sendOTP = async (formData) => {
        const now = moment();

        const data = {
            cases_create: 1,
            merchant_name_c: formData?.name,
            merchant_contact_number_c: formData?.phone,
            merchant_email_id_c: formData?.email,
            is_call_back: formData?.digitalPayment == "oneHourCall" ? 1 : 0,
            is_call_back_30_min:
                formData?.digitalPayment == "oneHourCall" ? 0 : 1,
            call_back_start_time_c:
                formData?.digitalPayment == "oneHourCall"
                    ? now.format("YYYY-M-D H:m:ss")
                    : moment(
                          `${formData?.date.toDateString()} ${formData?.time.toTimeString()}`
                      ).format("YYYY-M-D H:m:ss"),
        };

        await axios
            .post(process.env.REACT_APP_API_FORM_URL, data, {
                headers: {
                    "x-api-key": process.env.REACT_APP_AUTHORIZATION,
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json;charset=utf-8",
                },
            })
            .then((response) => {
                if (response.data?.body?.Success) {
                    // verifyOTP(response.data);
                    setSendOTPData(response.data?.body);
                    setShow(!show);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const verifyOTP = async () => {
        if (!otp) {
            return;
        }

        const data = {
            cases_create_otp_verify: 1,
            otp: otp,
            otp_id: sendOtpData?.otp_id,
        };

        axios
            .post(process.env.REACT_APP_API_FORM_URL, data, {
                headers: {
                    "x-api-key": process.env.REACT_APP_AUTHORIZATION,
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json;charset=utf-8",
                },
            })
            .then((response) => {
                if (response.data?.body?.Success) {
                    setShow(false);
                    resetFrom();
                    seterrorFormSubmit(false);
                    setshowFormSubmit(true);
                    setTimeout(() => {
                        setshowFormSubmit(false);
                    }, 5000);
                } else if (response.data?.body?.data == "Incorrect OTP") {
                    setInvalidOtpError("Incorrect OTP, Please try again.");
                } else {
                    seterrorFormSubmit(true);
                    setshowFormSubmit(true);
                    setTimeout(() => {
                        setshowFormSubmit(false);
                    }, 5000);
                }
            })
            .catch((error) => {
                console.error(
                    "Error:",
                    error.response ? error.response.data : error.message
                );
            });
    };

    const setDates = (time) => {
        var selecteD =
            time.getDate() + "-" + time.getMonth() + "-" + time.getFullYear();
        var todayD =
            new Date().getDate() +
            "-" +
            new Date().getMonth() +
            "-" +
            new Date().getFullYear();

        if (selecteD == todayD) {
            if (time.getHours() >= 16) {
                alert(
                    "Today, all the timeslots are full. Please pick a time for tomorrow."
                );
            } else {
                setsMinTime(new Date().setHours(time.getHours(), 0, 0));
                setsMaxTime(new Date().setHours(16, 0, 0));
            }

            setSelectedDate(time);
        } else {
            setsMinTime(new Date().setHours(9, 0, 0));
            setsMaxTime(new Date().setHours(17, 0, 0));
            setSelectedDate(time);
        }
    };
    const resetFrom = () => {
        reset();
        setSelectedDate("");
        setSelectedTime("");
    };

    return (
        <Fragment>
            <form
                id="contactForm"
                className="row"
                onSubmit={handleSubmit(submitForm)}
            >
                <div className="col-12 col-sm-6 mb-7">
                    <input
                        type="text"
                        className={`form-control ${
                            errors.name ? "is-invalid" : ""
                        }`}
                        placeholder="Your Full Name*"
                        {...register("name", {
                            required: "Name is required",
                            minLength: {
                                value: 3,
                                message:
                                    "Name must be at least 3 characters long",
                            },
                        })}
                    />
                    {errors.name && (
                        <p className="text-danger">{errors.name.message}</p>
                    )}
                </div>

                <div className="col-12 col-sm-6 mb-7">
                    <input
                        type="text"
                        className={`form-control ${
                            errors.phone ? "is-invalid" : ""
                        }`}
                        placeholder="Your Phone Number*"
                        {...register("phone", {
                            required: "Phone number is required",
                            pattern: {
                                value: /^[0-9]{10}$/,
                                message: "Phone number must be 10 digits",
                            },
                        })}
                    />
                    {errors.phone && (
                        <span className="text-danger">
                            {errors.phone.message}
                        </span>
                    )}
                </div>

                <div className="col-12 col-sm-12 mb-7">
                    <input
                        type="email"
                        className={`form-control ${
                            errors.email ? "is-invalid" : ""
                        }`}
                        placeholder="Your Email*"
                        {...register("email", {
                            required: "Email is required",
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: "Invalid email address",
                            },
                        })}
                    />
                    {errors.email && (
                        <span className="text-danger">
                            {errors.email.message}
                        </span>
                    )}
                </div>

                <div className="row col-12 col-sm-12 mb-7">
                    <div className="col-md-6">
                        <input
                            type="radio"
                            id="oneHourCall"
                            value={"oneHourCall"}
                            {...register("digitalPayment", {
                                required: "Please select an option",
                            })}
                            className="custom-control-input "
                            style={{
                                transform: "scale(1.4)",
                                accentColor: "green",
                            }}
                            onChange={handleRadioChange}
                        />
                        <label htmlFor="oneHourCall" className="ps-2">
                            1-hour Call Back
                        </label>
                    </div>
                    <div className="col-md-6 ">
                        <input
                            type="radio"
                            id="sheduleCall"
                            value={"sheduleCall"}
                            {...register("digitalPayment", {
                                required: "Please select an option",
                            })}
                            className="custom-control-input"
                            style={{
                                transform: "scale(1.4)",
                                accentColor: "green",
                            }}
                            onChange={handleRadioChange}
                        />
                        <label htmlFor="sheduleCall" className="ps-2">
                            Schedule a Call Back
                        </label>
                    </div>
                    {errors.digitalPayment && (
                        <span className="text-danger">
                            {errors.digitalPayment.message}
                        </span>
                    )}
                </div>

                {sheduleCall && (
                    <div className="row col-12 mx-0 px-0">
                        {/* Select Date */}
                        <div className="row col-12 col-md-6 mb-7 mx-0 px-0">
                            {/* <label className="form-label" htmlFor="selectDate">Select Date</label> */}
                            <DatePicker
                                id="selectDate"
                                selected={selectedDate}
                                className={`form-control ${
                                    errors.date ? "is-invalid" : ""
                                } w-100`}
                                onChange={(date) => {
                                    setValue("date", date); // Update react-hook-form's value
                                    trigger("date"); // Trigger validation
                                    setDates(date);
                                }}
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select a date"
                                autoComplete="off"
                                minDate={new Date()}
                                maxDate={maxAllowedDate}
                            />
                            {errors.date && (
                                <p className="text-danger">
                                    {errors.date.message}
                                </p>
                            )}
                        </div>

                        {/* Select Time */}
                        <div className="row col-12 col-md-6 mb-7 mx-0 px-0">
                            <DatePicker
                                id="time"
                                selected={selectedTime}
                                onChange={(time) => {
                                    setValue("time", time); // Update react-hook-form's value
                                    trigger("time"); // Trigger validation
                                    setSelectedTime(time);
                                }}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption="Time"
                                dateFormat="h:mm aa"
                                placeholderText="Select a time"
                                autoComplete="off"
                                minTime={sminTime}
                                maxTime={smaxTime}
                                className={`form-control ${
                                    errors.time ? "is-invalid" : ""
                                }`}
                            />
                            {errors.time && (
                                <p className="text-danger">
                                    {errors.time.message}
                                </p>
                            )}
                        </div>
                    </div>
                )}

                {/* <div className="col-12">
                    <input
                        type="hidden"
                        {...register("date", { required: "Date is required" })}
                    />
                    <input
                        type="hidden"
                        {...register("time", { required: "Time is required" })}
                    />
                </div> */}

                <div className="col-12 col-sm-12 mb-7">
                    <ReCAPTCHA
                        sitekey="6LfNVKwhAAAAAALvZZhsu-taEYh7NLaAIfkvUU7v"
                        onChange={onReCAPTCHAChange}
                    />
                </div>

                <div className="col-12 text-center">
                    <button
                        type="submit"
                        className="btn btn-xm btn-primary btn-hover-primary align-self-end"
                        disabled={!recaptchaToken}
                    >
                        Lets Talk
                    </button>
                </div>

                {/* <div className="col-12 mt-4">
                    <button
                        type="submit"
                        className="btn btn-xm btn-primary btn-hover-primary w-100"
                        // disabled={!isValid}
                    >
                        Submit
                    </button>
                </div> */}
            </form>

            {/* <div className={`modal ${show ? "show" : ""}`}> */}
            <div
                className={`modal ${show ? "show" : ""}`}
                style={{
                    backdropFilter: "blur(2px)",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    opacity: "1 !important",
                }}
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div
                        className="modal-content radius-box"
                        style={{ boxShadow: "0px 5px 5px -1px rgb(22 22 22)" }}
                    >
                        <div className="modal-header text-white">
                            <h5 className="modal-title">Verify OTP</h5>
                            <button
                                type="button"
                                className="btn-close btn btn-primary"
                                aria-label="Close"
                                onClick={() => setShow(!show)}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <p className="mt-2 mb-2">
                                <span className="text-dark">
                                    Please enter OTP to validate your phone
                                    number
                                </span>
                            </p>
                            <input
                                type="text"
                                className="form-control mt-2"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                placeholder="Enter OTP"
                            />

                            {invalidOtpError && (
                                <p>
                                    <span className="text-danger mt-4 pl-2">
                                        {invalidOtpError}
                                    </span>
                                </p>
                            )}
                        </div>

                        <button
                            type="button"
                            className="btn btn-sm btn-primary btn-hover-primary align-self-center my-2"
                            onClick={() => {
                                verifyOTP();
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>

            <div
                className={`modal ${showFormSubmit ? "show" : ""}`}
                style={{
                    backdropFilter: "blur(2px)",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    opacity: "1 !important",
                }}
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div
                        className="modal-content radius-box"
                        style={{ boxShadow: "0px 5px 5px -1px rgb(22 22 22)" }}
                    >
                        {/* <div className="modal-header text-white ">
                            <h5 className="modal-title ">NeoGrowth</h5>
                            <button
                                type="button"
                                className="btn-close btn btn-primary"
                                aria-label="Close"
                                onClick={() =>
                                    setshowFormSubmit(!showFormSubmit)
                                }
                            ></button>
                        </div> */}
                        <div className="modal-body text-center">
                            {errorFormSubmit ? (
                                <p className="mt-4 text-center">
                                    <span className="b-color">
                                        Technical error occurred.
                                        <br />
                                        <br />
                                        Please try again after sometime.
                                    </span>
                                </p>
                            ) : (
                                <p className="mt-4 text-center">
                                    <span className="b-color">
                                        Thank you for reaching out.
                                        <br />
                                        <br />
                                        Our team will connect with you shortly.
                                    </span>
                                </p>
                            )}

                            <button
                                type="button"
                                className="btn btn-sm btn-primary btn-hover-primary mt-2"
                                aria-label=""
                                onClick={() =>
                                    setshowFormSubmit(!showFormSubmit)
                                }
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default CallbackForm;
